// collecting all the components and creating the main app.
let { Vue, wp, axios } = window,
    { i18n } = wp,
    { createApp } = Vue;

// Importing all components from the components folder
import PostSmtpAppWrapper      from "components/post-smtp-app-wrapper.vue";
import PostSMTPHeader          from "components/post-smtp-header.vue";
import PostSmtpImg             from "components/post-smtp-img.vue";
import PostSmtpSettings        from "components/post-smtp-settings.vue";
import PostSmtpSettingsMenu    from "components/post-smtp-settings-menu.vue";
import PostSmtpNotificationBar from "components/post-smtp-notification-bar.vue";
import PostSmtpSidebar         from "components/post-smtp-sidebar.vue";
import PostSmtpGmailOneClickBanner from "components/post-smtp-gmail-one-click-banner.vue";
import PostSmtpWidget          from "components/post-smtp-widget.vue";
import PostSmtpAds             from "components/post-smtp-ads.vue";
import PostSmtpButton          from "components/post-smtp-button.vue";
import PostSmtpDashboard       from "components/post-smtp-dashboard.vue";
import PostSmtpDaysSelector    from "components/post-smtp-days-selector.vue";
import PostSmtpCardsContainer  from "components/post-smtp-cards-container.vue";
import PostSmtpCard            from "components/post-smtp-card.vue";
import PostSmtpBanners         from "components/post-smtp-banners.vue";
import PostSmtpNotice          from "components/post-smtp-notice.vue";
import PostSmtpLogsSection     from "components/post-smtp-logs-section.vue";
import PostSmtpLogActionMenu   from 'components/post-smtp-log-action-menu.vue'
import PostSmtpProFeatures     from "components/post-smtp-pro-features.vue";
import PostSmtpGuide           from "components/post-smtp-guide.vue";
import PostSmtpDocumentation   from "components/post-smtp-documentation.vue";

// Creating the main app
const post_smtp__app = createApp( {

    setup: () => ( {
        plugin_dir_url: postSmtpNewDashboard.plugin_dir_url,
        admin_url: postSmtpNewDashboard.admin_url,
    } ),

    data: () => ( {} ),

    watch: {},

    computed: {},

    methods: {},

    mounted() {
    },

} );

// registering plugins.
post_smtp__app.use( {
    install( app, options ) {
        app.provide( 'i18n', options );
    }
}, i18n );

// Registering all components
post_smtp__app.component( 'post-smtp-app-wrapper', PostSmtpAppWrapper );
post_smtp__app.component( 'post-smtp-header', PostSMTPHeader );
post_smtp__app.component( 'post-smtp-img', PostSmtpImg );
post_smtp__app.component( 'post-smtp-settings', PostSmtpSettings );
post_smtp__app.component( 'post-smtp-settings-menu', PostSmtpSettingsMenu );
post_smtp__app.component( 'post-smtp-notification-bar', PostSmtpNotificationBar );
post_smtp__app.component( 'post-smtp-sidebar', PostSmtpSidebar );
post_smtp__app.component( 'post-smtp-gmail-one-click-banner', PostSmtpGmailOneClickBanner );
post_smtp__app.component( 'post-smtp-widget', PostSmtpWidget );
post_smtp__app.component( 'post-smtp-ads', PostSmtpAds );
post_smtp__app.component( 'post-smtp-button', PostSmtpButton );
post_smtp__app.component( 'post-smtp-dashboard', PostSmtpDashboard );
post_smtp__app.component( 'post-smtp-days-selector', PostSmtpDaysSelector );
post_smtp__app.component( 'post-smtp-cards-container', PostSmtpCardsContainer );
post_smtp__app.component( 'post-smtp-card', PostSmtpCard );
post_smtp__app.component( 'post-smtp-banners', PostSmtpBanners );
post_smtp__app.component( 'post-smtp-notice', PostSmtpNotice );
post_smtp__app.component( 'post-smtp-logs-section', PostSmtpLogsSection );
post_smtp__app.component( 'post-smtp-log-action-menu', PostSmtpLogActionMenu );
post_smtp__app.component( 'post-smtp-pro-features', PostSmtpProFeatures );
post_smtp__app.component( 'post-smtp-guide', PostSmtpGuide );
post_smtp__app.component( 'post-smtp-documentation', PostSmtpDocumentation );

// Mounting the main app
post_smtp__app
    .mount( '#post-smtp-app' );
window
    .$post_smtp__app = post_smtp__app;